import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify"; // 👈 اضافه شد

const DisableTradingForm = ({ availableLogins = [], refetchConfigs }) => { // 👈 refetchConfigs اضافه شد
  const [formData, setFormData] = useState({
    target: "individuals",
    type: "all_individuals",
    reason: "",
    logins: [],
  });
  const [currentLogin, setCurrentLogin] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const payload = {
        target: formData.target,
        type: formData.type,
        reason: formData.reason,
      };

      if (formData.type === "custom_logins") {
        payload.logins = formData.logins;
      }

      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/trading/disable`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data.success || response.data.ok) {
        const successMessage = "معاملات با موفقیت غیرفعال شدند";
        setMessage(successMessage);
        toast.success(successMessage); // 👈 اضافه شد
        
        setFormData({
          target: "individuals",
          type: "all_individuals",
          reason: "",
          logins: [],
        });
        setCurrentLogin("");
        
        // 👇 refetch configs بعد از موفقیت
        if (refetchConfigs) {
          await refetchConfigs();
        }
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage = error.response?.data?.message || "خطا در غیرفعال‌سازی معاملات";
      setMessage(errorMessage);
      toast.error(errorMessage); // 👈 اضافه شد
    } finally {
      setLoading(false);
    }
  };

  const handleTargetChange = (newTarget) => {
    const newType =
      newTarget === "individuals" ? "all_individuals" : "all_groups";
    setFormData({
      ...formData,
      target: newTarget,
      type: newType,
      logins: [],
    });
  };

  const addLogin = () => {
    if (currentLogin.trim() && !formData.logins.includes(currentLogin.trim())) {
      setFormData({
        ...formData,
        logins: [...formData.logins, currentLogin.trim()],
      });
      setCurrentLogin("");
    }
  };

  const toggleLoginSelection = (login) => {
    if (formData.logins.includes(login)) {
      setFormData({
        ...formData,
        logins: formData.logins.filter((l) => l !== login),
      });
    } else {
      setFormData({
        ...formData,
        logins: [...formData.logins, login],
      });
    }
  };

  const removeLogin = (login) => {
    setFormData({
      ...formData,
      logins: formData.logins.filter((l) => l !== login),
    });
  };

  return (
    <div className="space-y-6 p-6">
      <div className="bg-red-900/20 border border-red-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>🚫</span> غیرفعال‌سازی معاملات
        </h3>
        <p className="text-red-300 text-sm">
          ⚠️ غیرفعال کردن امکان معامله برای حساب‌های انتخاب شده
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب (Target):
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) => handleTargetChange(e.target.value)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) => handleTargetChange(e.target.value)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Type Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            نوع عملیات (Type):
          </label>
          <div className="space-y-3">
            {formData.target === "individuals" ? (
              <>
                <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
                  <input
                    type="radio"
                    name="type"
                    value="all_individuals"
                    checked={formData.type === "all_individuals"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        type: e.target.value,
                        logins: [],
                      })
                    }
                    className="w-5 h-5 accent-red-600"
                  />
                  <div>
                    <div className="text-white font-medium">
                      همه حساب‌های فردی (All Individuals)
                    </div>
                    <div className="text-gray-400 text-sm">
                      غیرفعال‌سازی برای تمام حساب‌های فردی
                    </div>
                  </div>
                </label>
                <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
                  <input
                    type="radio"
                    name="type"
                    value="custom_logins"
                    checked={formData.type === "custom_logins"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        type: e.target.value,
                        logins: [],
                      })
                    }
                    className="w-5 h-5 accent-red-600"
                  />
                  <div>
                    <div className="text-white font-medium">
                      Login های سفارشی (Custom Logins)
                    </div>
                    <div className="text-gray-400 text-sm">
                      انتخاب دستی حساب‌های خاص
                    </div>
                  </div>
                </label>
              </>
            ) : (
              <>
                <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
                  <input
                    type="radio"
                    name="type"
                    value="all_groups"
                    checked={formData.type === "all_groups"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        type: e.target.value,
                        logins: [],
                      })
                    }
                    className="w-5 h-5 accent-red-600"
                  />
                  <div>
                    <div className="text-white font-medium">
                      همه گروه‌ها (All Groups)
                    </div>
                    <div className="text-gray-400 text-sm">
                      غیرفعال‌سازی برای تمام گروه‌ها
                    </div>
                  </div>
                </label>
                <label className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition">
                  <input
                    type="radio"
                    name="type"
                    value="custom_logins"
                    checked={formData.type === "custom_logins"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        type: e.target.value,
                        logins: [],
                      })
                    }
                    className="w-5 h-5 accent-red-600"
                  />
                  <div>
                    <div className="text-white font-medium">
                      Login های سفارشی (Custom Logins)
                    </div>
                    <div className="text-gray-400 text-sm">
                      انتخاب دستی گروه‌های خاص
                    </div>
                  </div>
                </label>
              </>
            )}
          </div>
        </div>

        {/* Custom Logins Selection */}
        {formData.type === "custom_logins" && (
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
            <label className="block text-white font-medium mb-3">
              انتخاب Login ها:
            </label>

            {/* افزودن دستی */}
            <div className="bg-gray-700 rounded-lg p-4 mb-4">
              <label className="block text-white text-sm font-medium mb-2">
                افزودن Login به صورت دستی:
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={currentLogin}
                  onChange={(e) => setCurrentLogin(e.target.value)}
                  placeholder="شماره Login را وارد کنید"
                  className="flex-1 p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-red-500 focus:outline-none"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addLogin();
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={addLogin}
                  disabled={!currentLogin.trim()}
                  className="px-4 py-3 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white rounded-lg transition duration-200 whitespace-nowrap"
                >
                  افزودن
                </button>
              </div>
            </div>

            {/* انتخاب از لیست */}
            {availableLogins.length > 0 && (
              <div className="mb-4">
                <label className="block text-white text-sm font-medium mb-2">
                  یا از لیست حساب‌های موجود انتخاب کنید:
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-h-60 overflow-y-auto bg-gray-900 p-3 rounded-lg">
                  {availableLogins.map((loginObj) => (
                    <label
                      key={loginObj.login}
                      className="flex items-center gap-3 bg-gray-700 p-3 rounded-lg cursor-pointer hover:bg-gray-600 transition"
                    >
                      <input
                        type="checkbox"
                        checked={formData.logins.includes(loginObj.login)}
                        onChange={() => toggleLoginSelection(loginObj.login)}
                        className="w-5 h-5 accent-red-600"
                      />
                      <div className="flex-1 min-w-0">
                        <div className="text-white font-medium truncate">
                          {loginObj.login}
                        </div>
                        {loginObj.name && (
                          <div className="text-gray-400 text-xs truncate">
                            {loginObj.name}
                          </div>
                        )}
                        <div
                          className={`text-xs ${
                            loginObj.isActive
                              ? "text-green-400"
                              : "text-red-400"
                          }`}
                        >
                          {loginObj.isActive ? "فعال" : "غیرفعال"}
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* نمایش Login های انتخاب شده */}
            {formData.logins.length > 0 && (
              <div className="bg-gray-900 rounded-lg p-3">
                <p className="text-gray-300 text-sm mb-2">
                  Login های انتخاب شده ({formData.logins.length} مورد):
                </p>
                <div className="flex flex-wrap gap-2">
                  {formData.logins.map((id) => (
                    <div
                      key={id}
                      className="bg-red-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2"
                    >
                      {id}
                      <button
                        type="button"
                        onClick={() => removeLogin(id)}
                        className="hover:bg-red-700 rounded-full p-1 transition duration-200"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {formData.logins.length === 0 && (
              <p className="text-gray-500 text-sm text-center py-3">
                هنوز Login ای انتخاب نشده است
              </p>
            )}
          </div>
        )}

        {/* دلیل */}
        <div>
          <label className="block text-white font-medium mb-2">
            دلیل غیرفعال‌سازی <span className="text-red-400">*</span>
          </label>
          <textarea
            value={formData.reason}
            onChange={(e) =>
              setFormData({ ...formData, reason: e.target.value })
            }
            placeholder="لطفاً دلیل غیرفعال‌سازی معاملات را توضیح دهید..."
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:outline-none resize-none"
            rows="4"
            required
          />
        </div>

        {/* Warning */}
        <div className="bg-yellow-900/20 border border-yellow-600 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">⚠️</span>
            <div>
              <h4 className="text-yellow-400 font-medium mb-2">هشدار</h4>
              <p className="text-gray-300 text-sm">
                با غیرفعال کردن معاملات، حساب‌های انتخاب شده قادر به انجام
                معامله نخواهند بود
              </p>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={
            loading ||
            !formData.reason.trim() ||
            (formData.type === "custom_logins" && formData.logins.length === 0)
          }
          className="w-full py-4 px-6 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال غیرفعال‌سازی...
            </>
          ) : (
            <>
              <span>🚫</span>
              غیرفعال‌سازی معاملات
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default DisableTradingForm;